export default {
  props: ['time', 'saleTypeText'],
  data() {
      return {
        cash: {
          sku_id: 1,
          image_name: "money",
          color: "badge-primary",
          goto: "Cash",
          image_path: require("../../assets/remoney.png"),
          title_name: [
            {
              name_id: 0,
              name: "Cash",
              say: "Payment by cash"
            },
            {
              name_id: 1,
              name: "เงินสด",
              say: "ชำระเงินโดย เงินสด"
            },
            {
              name_id: 2,
              name: "现金",
              say: "通過現金付款"
            }
          ]
        }
      }
    },
    methods: {
      checkTime () {
        this.$store.state.loopCash = setInterval(() => {
          console.log('cash time = ' + this.time)
          if (this.time == 0) {
            if(this.$store.state.AmountPayment >= this.$store.state.total){
              console.log("มีเงินอยู่")
            } else {
            // this.$socket.sendObj({
            //   command: 'receive_close'
            // })
            clearInterval(this.$store.state.loopCash)
            }
          }
        }, 1000)
      },
      ReceiveMoney() {
        try {
          this.$socket.sendObj({
            command: 'receive_open'
          })
          console.log("สั่งรับเงิน")
          this.$store.state.isLoading = true
          setTimeout(() => {
            if (this.$store.state.isLoading === true) {
              // this.$socket.sendObj({
              //   command: 'receive_close'
              // })
              this.$store.state.isLoading = false
              // alert('ระบบรับเงินมีปัญหา กรุณาทำรายการใหม่')
              // this.$router.go(-1)
              // this.$store.state.timeOut = 0
            }
          }, 5000)
        } catch (e) {
          alert('ระบบรับเงินมีปัญหา กรุณาทำรายการใหม่')
          this.$store.state.IDWallet = null
          this.$store.state.timeOut = 0
          this.$router.go(-1)
        }
      }
    },
    mounted() {
      console.log('cash ready!!')
      this.ReceiveMoney()
      this.checkTime()
    }
  };



// WEBPACK FOOTER //
// ./src/js/type/cash.js